// GENERATED by tools/scripts/generate-icons.mjs from libs/icons/svg/outline/check-circle.svg. Do not edit.

import { glyph } from '@gto/icons/glyphs/outline/check-circle'

import { Icon, type IconComponentProps } from '../icon'

export const CheckCircleIcon = (props: IconComponentProps) => (
  <Icon
    glyph={glyph}
    {...props}
  />
)
